import React, { useCallback } from 'react';

import { errorCatch, deleteInArray, GET, updateInArray, getLocator } from 'fennec-ui'
import { CollectionServer } from 'fennec-ui';
import AddControllerMeropriyatie from '../AddControllerMeropriyatie';
import User from '../../../common/User';
import ModernUserSelection from '../../components/ModernUserSelection';

var _ = require('lodash');

export default function SpecialguestMeropriyatiya(props) {
    const { auth, object } = props;
   
    const filters = () => [
        {
            label: "Идентификатор пользователя",
            name: "user.ID",
            sort: true,
            filter: true,
        },
        {
            name: "user.lastname",
            sort: true,
            filter: true,
        },
        {
            name: "user.firstname",
            sort: true,
            filter: true,
        },
        {
            name: "user.patronymic",
            sort: true,
            filter: true,
        },
        {
            name: "user.email",
            sort: true,
            filter: true,
        },
        {
            label: "Телефон",
            name: "user.phone",
            sort: true,
            filter: true,
        },
        {
            name: "user.gender",
            sort: true,
            filter: true,
        },
        {
            label: "Дата регистрации",
            name: "user.createdAt",
            type: "date",
            sort: true,
            filter: true,
        },
        {
            label: "Дата назначения",
            name: "createdAt",
            type: "date",
            sort: true,
            filter: true,
        }
    ];
    const render = (item, idx, { setCollection, setCollectionItem, update }) => {
        return (<div key={idx} style={{ width: "100%" }} className="clickable">
            <User item={item.user} />
        </div>)
    }
    const create = useCallback((values, unlock, close, { collection, setCollection }) => {
        GET(auth, `/api/eventuser/specialguest/add/${object?.ID}/${values.polzovatel.ID}`,
            ({ data }) => {
                setCollection(updateInArray(collection, data));
                close();
            }, (err) => errorCatch(err, unlock)
        );
    },[object])

    return (
        <>
            <CollectionServer
                name={"EventUser"}
                auth={auth}
                size="small"

                source={`/api/eventuser/specialguest/list/${object?.ID}`}
                filters={filters}

                mode={"list"}
                render={render}

                onItemLocator={(item,index)=>{
                    return getLocator("specialguest-"+item?.user?.email);
                }}

                collectionActions={() => [
                    {
                        action: create,
                        triggerOptions: {
                            type: "primary"
                        },
                        // form: AddControllerMeropriyatie,
                        form: ModernUserSelection,
                        options: {
                            initialValues: {},
                        },
                        title: "Добавить спец. гостя",
                        modal: {
                            minWidth: "250px",
                            title: "Новый спец. гость",
                        }
                    }
                ]}
                modelActions={(item) => [
                    {
                        title: "Удалить",
                        action: (values, unlock, close, { collection, setCollection }) => {
                            GET(auth, `/api/eventuser/specialguest/delete/${item.ID}`,
                                () => setCollection(deleteInArray(collection, item)), errorCatch
                            );
                        },
                    }
                ]}
            />
        </>
    );
}
